'use client'

import { usePathname } from 'next/navigation'
import { MenuItem } from 'shared/common/Menubar/ui/MenuItem/Mobile'
import { IconNames } from 'shared/iconpack/model/types'
import { TokenStorage } from 'shared/libs/storage'
import { getCookie } from 'shared/libs/storage/cookie'
import { trackAppVisit } from 'shared/metrics'

import { ReactNode, useEffect } from 'react'

import { useGetMeQuery } from 'modules/Auth/model/api'
import { CartBadge } from 'modules/Cart/components/CartBadge/Universal'

import { RouterPath } from 'shared/config/routerPath/RouterPath'

import styles from './Menu.module.scss'

type MenuItem =
  | {
      path: RouterPath
      icon: IconNames
      label: string
      badgeCount?: number
    }
  | { component: ReactNode }

export function Menu() {
  const token = TokenStorage.getFromStorage()
  const { data, isFetching, isSuccess } = useGetMeQuery(undefined, {
    skip: !token,
  })

  const isWebview = getCookie('isWebview')

  useEffect(() => {
    if (
      !isFetching &&
      isSuccess &&
      data &&
      typeof window !== 'undefined' &&
      isWebview
    ) {
      trackAppVisit(data.id, data.phone_number)
    }
  }, [data, isFetching, isSuccess, isWebview])

  const pathname = usePathname()
  const menuItems: MenuItem[] = [
    { path: RouterPath.HOME, icon: 'home', label: 'Главная' },
    { path: RouterPath.CATEGORY, icon: 'catalog', label: 'Каталог' },
    {
      component: (
        <CartBadge
          isMobile
          key={'cart'}
          isActive={
            pathname.startsWith(RouterPath.CART) || pathname === RouterPath.CART
          }
          className={`${styles.link} ${pathname === RouterPath.CART ? styles.active : ''}`}
        />
      ),
    },
    {
      path: RouterPath.PROFILE,
      icon: 'person',
      label: 'Профиль',
    },
  ]

  return (
    <div className={styles.menu}>
      {menuItems.map(menuItem => {
        if ('component' in menuItem) {
          return menuItem.component
        }
        const isActive =
          menuItem.icon === 'catalog'
            ? pathname.startsWith(RouterPath.CATEGORY) ||
              pathname.startsWith('/catalog')
            : pathname.startsWith(menuItem.path + '/') ||
              pathname === menuItem.path

        return (
          <MenuItem key={menuItem.path} {...menuItem} isActive={isActive} />
        )
      })}
    </div>
  )
}
